import SimpleSlider from "../Components/HomePage/SlickCarousel"



import Footer from "../Components/Footer/Footer";

function Home(){
    return <div>
        
<SimpleSlider/>
   
    </div>
}
export default Home;